import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  NumberInput,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { sky_blue } from "../../../../../const/variables";
import { tblPromotionItemPrimaryCommand } from "../../../../../model/TblPromotion";

const ModalItemPrimaryEditDiscount = ({
  dataEdit,
  editItemDiscount,
  typePromotion,
}: {
  dataEdit: tblPromotionItemPrimaryCommand;
  editItemDiscount: (dataSubmit: tblPromotionItemPrimaryCommand) => void;
  typePromotion: string;
}) => {
  const entity =
    typePromotion === "1" ? dataEdit : { ...dataEdit, discountPercent: null };

  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {
      quantityMax: (value, values) => {
        if (value && values.quantityMin && value < values.quantityMin) {
          return "Số lượng tối đa không được nhỏ hơn số lượng tối thiểu";
        }
      },
      quantityMin: (value, values) => {
        if (value && values.quantityMax && value > values.quantityMax) {
          return "Số lượng tối đa không được nhỏ hơn số lượng tối thiểu";
        }
      },
    },
  });

  return (
    <div>
      <Box
        component="form"
        onSubmit={form.onSubmit((e) => {
          editItemDiscount(e);
        })}
      >
        <Grid mt="md">
          {typePromotion === "1" ? (
            <Grid.Col span={4}>
              <TextInput
                label="% chiết khấu"
                placeholder="Nhập %"
                type="number"
                disabled={!!form.values.discountAmount || !!form.values.price}
                {...form.getInputProps("discountPercent")}
              />
            </Grid.Col>
          ) : (
            <></>
          )}
          <Grid.Col span={typePromotion !== "1" ? 6 : 4}>
            <NumberInput
              label="Số tiền chiết khấu"
              placeholder="Nhập số tiền"
              hideControls
              thousandSeparator="."
              allowNegative={false}
              decimalSeparator=","
              disabled={
                typePromotion === "1"
                  ? !!form.values.discountPercent || !!form.values.price
                  : !!form.values.price
              }
              {...form.getInputProps("discountAmount")}
              onChange={(e) => {
                form.getInputProps("discountAmount").onChange(e);
              }}
            />
          </Grid.Col>
          <Grid.Col span={typePromotion !== "1" ? 6 : 4}>
            <NumberInput
              label="Giá tiền áp dụng trong CTKM"
              placeholder="Nhập giá tiền"
              hideControls
              thousandSeparator="."
              allowNegative={false}
              decimalSeparator=","
              disabled={
                typePromotion === "1"
                  ? !!form.values.discountAmount ||
                    !!form.values.discountPercent
                  : !!form.values.discountAmount
              }
              {...form.getInputProps("price")}
            />
          </Grid.Col>
        </Grid>
        <Grid mt="md">
          <Grid.Col span={4}>
            <NumberInput
              label="Số Lượng tối thiểu"
              placeholder="Nhập số lượng"
              hideControls
              {...form.getInputProps("quantityMin")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <NumberInput
              label="Số Lượng tối đa"
              placeholder="Nhập số lượng"
              hideControls
              {...form.getInputProps("quantityMax")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <NumberInput
              label="Số lượng áp dụng"
              placeholder="Nhập số lượng"
              hideControls
              {...form.getInputProps("attribute3")}
            />
          </Grid.Col>
        </Grid>
        <Grid mt="md">
          <Grid.Col span={4}>
            <NumberInput
              label="Hãng/NCC tài trợ"
              placeholder="Nhập số tiền"
              hideControls
              thousandSeparator="."
              decimalSeparator=","
              {...form.getInputProps("attribute6")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <Checkbox
              mt={30}
              label="Nổi bật"
              checked={form.getValues()?.attribute4 === "Y"}
              onClick={() =>
                form.setValues((prev) => ({
                  ...prev,
                  attribute4: form.getValues()?.attribute4 === "Y" ? "N" : "Y",
                }))
              }
            />
          </Grid.Col>
        </Grid>

        <Group justify="end" mt="md">
          <Button
            type="button"
            color="gray"
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={<IconWindow size={18} />}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
        </Group>
      </Box>
    </div>
  );
};

export default ModalItemPrimaryEditDiscount;
